import { render, staticRenderFns } from "./modelviewer-slide.vue?vue&type=template&id=71094496&scoped=true&"
import script from "./modelviewer-slide.vue?vue&type=script&lang=js&"
export * from "./modelviewer-slide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71094496",
  null
  
)

export default component.exports